module.exports = __webpack_public_path__ + "static/media/chevron-left.d6a64e5b.svg";